"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatBlock = void 0;
const react_1 = __importStar(require("react"));
const models_1 = require("../models");
const HostBubble_1 = require("./bubbles/HostBubble");
const Input_1 = require("./Input");
const GuestBubble_1 = require("./bubbles/GuestBubble");
const react_transition_group_1 = require("react-transition-group");
const store_1 = require("../store");
const HostAvatar_1 = require("./bubbles/avatars/HostAvatar");
const PreviousButton_1 = require("./Input/components/buttons/PreviousButton");
const EndBlock_1 = require("./EndBlock");
const __1 = require("..");
var ChatBlockStatus;
(function (ChatBlockStatus) {
    ChatBlockStatus[ChatBlockStatus["QUESTION_BUBBLES"] = 0] = "QUESTION_BUBBLES";
    ChatBlockStatus[ChatBlockStatus["INPUT"] = 1] = "INPUT";
    ChatBlockStatus[ChatBlockStatus["REPLY_BUBBLES"] = 2] = "REPLY_BUBBLES";
    ChatBlockStatus[ChatBlockStatus["END"] = 3] = "END";
})(ChatBlockStatus || (ChatBlockStatus = {}));
const ChatBlock = ({ step, onReply, keepLastAvatar, rollbackToInput = false, continueWithPreviousAnswers, isSpeedTesting, onSkipToNextBlock, onNewBubble, }) => {
    const answersFromStore = (0, store_1.useStoreState)((state) => state.chatbotAnswers.value);
    const [status, setStatus] = (0, react_1.useState)(ChatBlockStatus.QUESTION_BUBBLES);
    const [answer, setAnswer] = (0, react_1.useState)();
    const [questionBubbles, setQuestionBubbles] = (0, react_1.useState)([]);
    const [replyBubbles, setReplyBubbles] = (0, react_1.useState)([]);
    const [avatarTopOffset, setAvatarTopOffset] = (0, react_1.useState)("0");
    const [avatarTopOffsetReply, setAvatarTopOffsetReply] = (0, react_1.useState)("0");
    const scrollingSideBlockRef = (0, react_1.useRef)(null);
    const scrollingSideBlockRefReplies = (0, react_1.useRef)(null);
    const containerRef = (0, react_1.useRef)(null);
    // Used to delay visibility of input (fix scroll too early if input too deep)
    const [showInput, setShowInput] = (0, react_1.useState)(false);
    const [showTryMessage, setShowTryMessage] = (0, react_1.useState)(false);
    const handleResize = () => {
        if (scrollingSideBlockRef.current) {
            setAvatarTopOffset(`${scrollingSideBlockRef.current.offsetTop}px`);
        }
        if (scrollingSideBlockRefReplies.current) {
            setAvatarTopOffsetReply(`${scrollingSideBlockRefReplies.current.offsetTop}px`);
        }
    };
    (0, react_1.useEffect)(() => {
        setTimeout(handleResize, 50);
    });
    (0, react_1.useEffect)(() => {
        onNewBubble();
    }, [status, questionBubbles, replyBubbles]);
    (0, react_1.useEffect)(() => {
        if (rollbackToInput) {
            setStatus(ChatBlockStatus.INPUT);
            setShowInput(true);
        }
    }, [rollbackToInput]);
    (0, react_1.useEffect)(() => {
        if (continueWithPreviousAnswers || isSpeedTesting) {
            setQuestionBubbles([...step.questionMessages]);
            if (step.answerType === models_1.InputType.NO_INPUT) {
                if (isSpeedTesting)
                    onSkipToNextBlock();
                return;
            }
            const existingAnswer = answersFromStore
                .filter((answer) => answer.questionId === step.id)
                .pop();
            if (existingAnswer && !isSpeedTesting) {
                setAnswer(existingAnswer);
                setStatus(ChatBlockStatus.REPLY_BUBBLES);
                if (step.replyMessages) {
                    setReplyBubbles([...step.replyMessages]);
                }
            }
            else {
                setStatus(ChatBlockStatus.INPUT);
                setShowInput(true);
                if (models_1.InputType.SHARE === step.answerType) {
                    setShowTryMessage(true);
                }
            }
            return;
        }
        if (step.questionMessages && step.questionMessages[0]) {
            setQuestionBubbles([step.questionMessages[0]]);
        }
        else {
            setStatus(ChatBlockStatus.INPUT);
            setTimeout(() => {
                setShowInput(true);
            }, 1);
        }
    }, []);
    const handleInputSubmit = (answer, freshQuestionVariables) => __awaiter(void 0, void 0, void 0, function* () {
        setAnswer(answer);
        setStatus(ChatBlockStatus.REPLY_BUBBLES);
        if (step.replyMessages &&
            step.replyMessages.length > 0 &&
            !answer.isRetry) {
            setReplyBubbles([step.replyMessages[0]]);
        }
        else {
            onReply(answer, freshQuestionVariables);
        }
    });
    const displayNextBubble = () => {
        var _a, _b, _c, _d;
        if (status === ChatBlockStatus.QUESTION_BUBBLES) {
            if (questionBubbles.length < step.questionMessages.length) {
                setQuestionBubbles([
                    ...questionBubbles,
                    step.questionMessages[questionBubbles.length],
                ]);
            }
            else if (step.answerType === models_1.InputType.NO_INPUT) {
                const answer = {
                    stepIndex: step.chatbotStepIndex,
                    questionContent: (0, __1.parseQuestionLabel)(step, step.chatbotStepIndex, []),
                    questionType: step.answerType,
                    value: "",
                    questionId: step.id,
                };
                onReply(Object.assign({}, answer));
                setStatus(ChatBlockStatus.END);
            }
            else {
                setStatus(ChatBlockStatus.INPUT);
                setTimeout(() => {
                    setShowInput(true);
                }, 1);
                if (step.answerType === models_1.InputType.SHARE) {
                    setShowTryMessage(true);
                }
            }
        }
        if (status === ChatBlockStatus.REPLY_BUBBLES &&
            replyBubbles.length < ((_b = (_a = step.replyMessages) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0)) {
            setReplyBubbles([
                ...replyBubbles,
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                step.replyMessages[replyBubbles.length],
            ]);
            return;
        }
        if (status === ChatBlockStatus.REPLY_BUBBLES &&
            replyBubbles.length === ((_d = (_c = step.replyMessages) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0)) {
            if (!answer)
                return;
            onReply(answer);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "flex", ref: containerRef },
            react_1.default.createElement("div", { className: "flex w-6 xs:w-10 mr-2 flex-shrink-0 items-center relative" },
                react_1.default.createElement("div", { className: "absolute w-6 h-6 xs:w-10 xs:h-10 mb-4 xs:mb-2 flex items-center top-0", style: {
                        top: avatarTopOffset,
                        transition: "top 500ms ease-out",
                    } },
                    react_1.default.createElement(react_transition_group_1.CSSTransition, { classNames: "bubble", timeout: 1000, in: questionBubbles.length > 0 && keepLastAvatar, unmountOnExit: true },
                        react_1.default.createElement(HostAvatar_1.HostAvatar, null))),
                react_1.default.createElement("div", { className: "absolute w-6 h-6 mb-4 xs:mb-2 xs:w-10 xs:h-10 flex items-center bottom-0", ref: scrollingSideBlockRef },
                    react_1.default.createElement("div", { className: "w-full h-full" }))),
            react_1.default.createElement("div", { className: "flex flex-col w-full" },
                react_1.default.createElement(react_transition_group_1.TransitionGroup, { enter: !continueWithPreviousAnswers }, questionBubbles.map((question) => (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: question.id, classNames: "bubble", timeout: 500, unmountOnExit: true },
                    react_1.default.createElement(HostBubble_1.HostBubble, { message: question.value, onTransitionEnd: continueWithPreviousAnswers || isSpeedTesting
                            ? () => undefined
                            : displayNextBubble, onResize: handleResize, skipAnimations: continueWithPreviousAnswers || isSpeedTesting }))))))),
        status !== ChatBlockStatus.REPLY_BUBBLES && (react_1.default.createElement("div", { className: showInput ? "bubble-enter-active" : "bubble-enter", style: {
                display: status === ChatBlockStatus.INPUT ? "flex" : "none",
            } },
            react_1.default.createElement(PreviousButton_1.PreviousButton, { className: "mr-2" }),
            react_1.default.createElement(Input_1.Input, { onSubmit: handleInputSubmit, type: step.answerType, inputOptions: step.questionOptions }))),
        status === ChatBlockStatus.REPLY_BUBBLES && (answer === null || answer === void 0 ? void 0 : answer.value) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(GuestBubble_1.GuestBubble, { message: answer.value }),
            step.replyMessages &&
                step.replyMessages.length > 0 &&
                !answer.isRetry && (react_1.default.createElement("div", { className: "flex" },
                react_1.default.createElement("div", { className: "flex w-6 xs:w-10 mr-2 flex-shrink-0 items-center relative" },
                    react_1.default.createElement("div", { className: "absolute w-6 h-6 xs:w-10 xs:h-10 mb-4 xs:mb-2 flex items-center top-0", style: {
                            top: avatarTopOffsetReply,
                            transition: "top 500ms ease-out",
                        } },
                        react_1.default.createElement(react_transition_group_1.CSSTransition, { enter: !(continueWithPreviousAnswers || isSpeedTesting), classNames: "bubble", timeout: 1000, in: step.showReplyAvatar, unmountOnExit: true },
                            react_1.default.createElement(HostAvatar_1.HostAvatar, null))),
                    react_1.default.createElement("div", { className: "absolute w-6 h-6 xs:w-10 xs:h-10 mb-4 xs:mb-2 flex items-center bottom-0", ref: scrollingSideBlockRefReplies },
                        react_1.default.createElement("div", { className: "w-full" }))),
                react_1.default.createElement("div", { className: "flex flex-col w-full" },
                    react_1.default.createElement(react_transition_group_1.TransitionGroup, { enter: !(continueWithPreviousAnswers || isSpeedTesting) }, replyBubbles.map((reply) => (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: reply.id, classNames: "bubble", timeout: 500, unmountOnExit: true },
                        react_1.default.createElement(HostBubble_1.HostBubble, { message: reply.value, onTransitionEnd: continueWithPreviousAnswers || isSpeedTesting
                                ? () => undefined
                                : displayNextBubble, onResize: handleResize, skipAnimations: continueWithPreviousAnswers || isSpeedTesting })))))))))),
        react_1.default.createElement(react_transition_group_1.CSSTransition, { classNames: "bubble", timeout: 1000, in: showTryMessage, unmountOnExit: true },
            react_1.default.createElement(EndBlock_1.EndBlock, null))));
};
exports.ChatBlock = ChatBlock;
//# sourceMappingURL=index.js.map